import { render } from "./EducationComponent.vue?vue&type=template&id=c9ef98f2"
import script from "./EducationComponent.vue?vue&type=script&lang=js"
export * from "./EducationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__